import axiosInstance from "./config";
import { ICouponCreate } from "views/admin/coupons/types/coupons.interface";

const basePath = `/induk-app/coupons`;

export const getCoupons = (page?: number, search?: string) => {
  return axiosInstance.get(`${basePath}`, {
    params: {
      page,
      search,
    },
  });
};

export const addCoupon = (payload: ICouponCreate) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    formData.append(key, value as string);
  });

  return axiosInstance.post(`${basePath}/create`, formData);
};

export const getCoupon = (slug: string) => {
  return axiosInstance.get(`${basePath}/${slug}`);
};

export const updateCoupon = (slug: string, coupon: Partial<ICouponCreate>) => {
  const formData = new FormData();
  Object.entries(coupon).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    formData.append(key, value as string);
  });

  return axiosInstance.patch(`${basePath}/${slug}/update`, formData);
};

export const deleteCoupon = (slug: string) => {
  return axiosInstance.delete(`${basePath}/${slug}/delete`);
};
